"use client";

import { Suspense } from "react";
import Loading from "../app/loading";
import Promotional from "../components/homepage/promotional";
import Products from "../components/homepage/products";
import HowItWorks from "../components/homepage/howItWorks";
import Videos from "../components/homepage/youtubevideos";
import Marketing from "../components/homepage/marketingSlider";
import ClientSlider from "../components/homepage/clientSlider";
import Graph from "../components/homepage/graph";
import BlogCarousel from "../components/homepage/blogCrousel"; // Use BlogCarousel directly
import Review from "../components/homepage/reviews";
import Faq from "../components/homepage/faq";
import Link from "next/link";

interface Post {
  slug: { _type: string; current: string };
  thumbImage: { asset: { url: string } };
  title: string;
}

interface ClientHomeProps {
  blogPosts: Post[];
}

export default function ClientHome({ blogPosts }: ClientHomeProps) {
  return (
    <>
      <Suspense fallback={<Loading />}>
        <Promotional />
      </Suspense>
      <Suspense fallback={<Loading />}>
        <Products />
      </Suspense>
      <Suspense fallback={<Loading />}>
        <HowItWorks />
      </Suspense>
      <Suspense fallback={<Loading />}>
        <Videos />
      </Suspense>
      <Suspense fallback={<Loading />}>
        <Marketing />
      </Suspense>
      <Suspense fallback={<Loading />}>
        <ClientSlider />
      </Suspense>
      <Suspense fallback={<Loading />}>
        <Graph />
      </Suspense>
      <Suspense fallback={<Loading />}>
        <div className="bg-theme mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-10">
          <Link href="/digital-gold-blog" className="cursor-pointer">
            <h1 className="text-center text-yellow-500 text-3xl sm:text-5xl font-extrabold mb-0 sm:mb-6">
              Our Blogs
            </h1>
          </Link>
          <div className="sm:pb-10">
            <BlogCarousel posts={blogPosts} />
          </div>
        </div>
      </Suspense>
      <Suspense fallback={<Loading />}>
        <Review />
      </Suspense>
      <Suspense fallback={<Loading />}>
        <Faq />
      </Suspense>
    </>
  );
}